// Libs
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { downloadFiles } from '../Capture/actions'

import withParams from '../../hoc/WithParams'

// CSS
import "./styles.scss"

class DownloadKroton extends Component {

  UNSAFE_componentWillMount() {
    const { lawsuitNumber, downloadFiles } = this.props
    downloadFiles(lawsuitNumber, true)

  }

  render() {
    return (
      <div className="download-kroton">
        <h1>Seu download está sendo feito. Por favor, aguarde um momento e não feche seu navegador.</h1>
      </div>
    )
  }
}

DownloadKroton = connect(
  (state, ownProps) => ({
    lawsuitNumber: ownProps.params.lawsuitNumber,
  }), { downloadFiles })(DownloadKroton)

export default withParams(DownloadKroton)